export const NO_BREAK_SPACE = "\u00a0"
export const ADDRESS_NULL = "0x0000000000000000000000000000000000000000"
